import React from 'react';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';


function Footer() {

  const {
    footerData
  } = useSelector(state => state.commonReducer);

  return (
    <div className={styles["w-footer"]}>
      <div className={styles["foot-wp"]}>
        <div className="w" style={{display: 'flex'}}>
          <div className={styles.logo}>
            {
              footerData?.indexLogo?.[0]?.imgLogo && <i style={{backgroundImage: `url(${footerData?.indexLogo?.[0]?.imgLogo})`}}></i>
            }
          </div>
          <div className={styles.col}>
            <ul>
              {
                footerData?.content?.map((footerItem, footerItemIdx) => {
                  const content = footerItem?.content || [];
                  const text = footerItem?.text
                  return(
                    <li key={`${footerItemIdx}-${text}`}>
                      <span className={styles.title}>{text}</span>
                      {
                        content.map((detail, detailIdx) => {
                          const detaiText = detail?.text;
                          const detailLink = detail?.linkText;
                          return(
                            <a key={`${detaiText}-${detailIdx}`} href={detailLink} target="_blank" rel="noopener noreferrer">{detaiText}</a>
                          )
                        })
                      }
                    </li>
                  )
                })
              }
            </ul>
          </div>
        </div>
        <a className={styles["foot-bm"]} target="_blank" href={footerData?.indexLogo?.[0]?.linkText} rel="noopener noreferrer">{footerData?.desc}</a>
      </div>
    </div>
  )
}

export default Footer;